import { RecordState, IRecord } from "../interfaces/interfaces";

type RecordAction =
  | { type: "getRecords"; payload: IRecord[] }
  | { type: "getDeletedRecords"; payload: IRecord[] }
  | { type: "addRecord"; payload: IRecord }
  | { type: "addDeletedRecord"; payload: IRecord }
  | { type: "editRecord"; payload: IRecord }
  | { type: "addEditForm"; payload: IRecord }
  | { type: "deleteRecord"; payload: IRecord }
  | { type: "restoreRecord"; payload: IRecord };

export const CartReducer = (
  state: RecordState,
  action: RecordAction
): RecordState => {
  switch (action.type) {
    case "getRecords":
      return {
        ...state,
        records: action.payload,
      };

    case "getDeletedRecords":
      return {
        ...state,
        deletedRecords: action.payload,
      };

    case "addRecord":
      let newStateAddRecords = [...state.records];
      newStateAddRecords.unshift(action.payload);
      return {
        ...state,
        records: newStateAddRecords,
      };

    case "addDeletedRecord":
      let newStateAddDeletedRecords = [...state.deletedRecords];
      newStateAddDeletedRecords.unshift(action.payload);
      return {
        ...state,
        deletedRecords: newStateAddDeletedRecords,
      };

    case "editRecord":
      let newStateEditRecords = [...state.records];
      newStateEditRecords = newStateEditRecords.map((record) => {
        if (record._id === action.payload._id) {
          record = action.payload;
        }
        return record;
      });
      return {
        ...state,
        records: newStateEditRecords,
      };
    case "addEditForm":
      return {
        ...state,
        editForm: action.payload,
      };
    case "deleteRecord":
      let newStateDeleteRecords = [...state.records].filter(
        (record) => record._id !== action.payload._id
      );
      return {
        ...state,
        records: newStateDeleteRecords,
      };
    case "restoreRecord":
      let newStateRestoreRecords = [...state.deletedRecords].filter(
        (record) => record._id !== action.payload._id
      );
      return {
        ...state,
        deletedRecords: newStateRestoreRecords,
      };

    default:
      return state;
  }
};
